import { Map } from "immutable";

import postsActions from "./actions";

const benefitsReqObj = {};
const benefits = {};
const benefitsFetching = false;

const initState = new Map({
  benefitsReqObj,
  benefits,
  benefitsFetching
});

export default function benefitsReducer(state = initState, action) {
  switch (action.type) {
    case postsActions.GET_BENEFITS_AND_PAYMENTS:
      return state.set("benefitsReqObj", action.data ? action.data : {}).set("benefitsFetching", true);
    case postsActions.GET_BENEFITS_AND_PAYMENTS_SUCCESS:
      return state.set("benefits", action.response.data).set("benefitsFetching", false);
    case postsActions.GET_BENEFITS_AND_PAYMENTS_ERROR:
      return state.set("benefitsFetching", false);
    default:
      return state;
  }
}
